import React from "react";
import "./Portfolio2.css";

const Portfolio2 = () => {
  return (
    <div className="portfolio" id="portfolio">
      {/* heading */}
      <span className="blued">Inauguration ESISA ANALYTICA</span>
      <span style={{ margin: "2rem 0" }} className="blued">et Signature avec C-19</span>

      {/* Conteneur de la vidéo YouTube */}
      <div className="video-container">
        {/* iframe YouTube */}
        <iframe
          className="youtube-video"
          width="100%" /* Utilise toute la largeur du conteneur */
          height="100%" /* Ajuste la hauteur automatiquement */
          src="https://www.youtube.com/embed/1y1d6cxdqlA?autoplay=0" /* Lien de la vidéo YouTube */
          title="Inauguration ESISA ANALYTICA"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      </div>
    </div>
  );
};

export default Portfolio2;
